import { Typography, WithStyles, withStyles } from "@material-ui/core";
import { styles } from "./RegisterUserOnBehalfView.styles";
import React from "react";
import { CenteredContainer } from "../../../components/CenteredContainer/CenteredContainer";

export interface IRegisterUserOnBehalfSuccessViewProps extends WithStyles<typeof styles> {}

const RegisterUserOnBehalfSuccessViewPure: React.FunctionComponent<IRegisterUserOnBehalfSuccessViewProps> = ({
    classes
}) => {

    return (
        <CenteredContainer>
            <div className={classes.title}>
                <Typography variant="h2">Register User on Behalf</Typography>
            </div>
            <Typography variant="h3">Success!</Typography>
            <Typography variant="body1">A new user has been registered.</Typography>
        </CenteredContainer>
    );
};

export const RegisterUserOnBehalfSuccessView = withStyles(styles)(RegisterUserOnBehalfSuccessViewPure);
